import { render, staticRenderFns } from "./PaymentDone.vue?vue&type=template&id=2f00ab4c&"
import script from "./PaymentDone.vue?vue&type=script&lang=js&"
export * from "./PaymentDone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports